import React from 'react'
import Snackbar from '@material-ui/core/Snackbar'
import Popover from '@material-ui/core/Popover'
import { Grid } from '@material-ui/core/'
import Copy from './copy'
import Button from '@material-ui/core/Button'
import CopyIcon from '@material-ui/icons/LibraryBooks'
import Typography from '@material-ui/core/Typography/Typography'
import { strings } from '../../../localization/strings'
import {
    MailLinkWrapper,
    WhatsAppLinkWrapper,
} from '../../components/linkWrappers'
import MailIcon from '@material-ui/icons/Mail'
import { QrCodeIcon } from '../../components/icons'
import { WhatsAppIcon } from '../../components/icons'
import IconButton from '@material-ui/core/IconButton/IconButton'
import ShareIcon from '@material-ui/icons/Share'
import { sendSms } from '../../../helpers/restHelpers'

class TrackingShare extends React.Component {
    state = {
        snackbarOpen: false,
        snackbarMessage: '',
        anchorEl: null,
    }

    handleCloseSnackbar = () => this.setState({ snackbarOpen: false })

    handleCloseMenu = () => this.setState({ anchorEl: null })

    showNotification = (message) =>
        this.setState({ snackbarOpen: true, snackbarMessage: message })

    sendSms = (orderId) =>
        sendSms(orderId)
            .then(() =>
                window.showDialog({
                    title: strings.trackingFormTitle,
                    message: strings.sendSmsSuccessDialog,
                })
            )
            .catch(() =>
                window.showDialog({
                    title: strings.trackingFormTitle,
                    message: strings.sendSmsErrorDialog,
                })
            )

    render() {
        let { url, mail, mobilePhoneNumber, canSendSms, orderId } = this.props

        if (!this.existsString(url)) return null

        return (
            <div
                style={{
                    width: '95%',
                    border: '2px solid #f7b500',
                    borderRadius: 8,
                    margin: 'auto',
                    overflowWrap: 'anywhere',
                    padding: 4,
                }}
            >
                <Snackbar
                    key={'snackbar'}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    open={this.state.snackbarOpen}
                    autoHideDuration={1000}
                    onClose={this.handleCloseSnackbar}
                    message={
                        <span id="message-id">
                            {this.state.snackbarMessage}
                        </span>
                    }
                />
                <Popover
                    anchorEl={this.state.anchorEl}
                    keepMounted
                    open={Boolean(this.state.anchorEl)}
                    onClose={this.handleCloseMenu}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    style={{ margin: 0 }}
                >
                    <Grid
                        container
                        direction="column"
                        style={{
                            marginLeft: 0,
                            marginRight: 10,
                            marginTop: 10,
                            marginBottom: 10,
                        }}
                    >
                        {!this.existsString(mail) ? null : (
                            <Grid
                                container
                                item
                                wrap="nowrap"
                                justify="flex-start"
                                style={{
                                    marginLeft: 10,
                                    marginRight: 0,
                                    marginTop: 5,
                                    marginBottom: 5,
                                }}
                            >
                                <Grid item style={{ marginLeft: 0 }}>
                                    <MailLinkWrapper
                                        mail={mail}
                                        subject={this.getMailSubject()}
                                        body={this.getMailBody()}
                                    >
                                        <Button
                                            color="primary"
                                            variant="contained"
                                            size="small"
                                        >
                                            <MailIcon
                                                color="inherit"
                                                style={{
                                                    width: 24,
                                                    height: 24,
                                                }}
                                            />
                                        </Button>
                                    </MailLinkWrapper>
                                </Grid>
                                <Grid item>
                                    <Typography
                                        variant="subtitle1"
                                        color="default"
                                        style={{
                                            marginRight: 20,
                                            textAlign: 'left',
                                            wordWrap: 'break-word',
                                        }}
                                    >
                                        {strings.trackingLinkSendMail}
                                    </Typography>
                                </Grid>
                            </Grid>
                        )}
                        {!this.existsString(mobilePhoneNumber) ? null : (
                            <Grid
                                container
                                item
                                wrap="nowrap"
                                justify="flex-start"
                                style={{
                                    marginLeft: 10,
                                    marginRight: 0,
                                    marginTop: 5,
                                    marginBottom: 5,
                                }}
                            >
                                <Grid item style={{ marginLeft: 0 }}>
                                    <WhatsAppLinkWrapper
                                        countryPrefix="54"
                                        mobilePhoneNumber={mobilePhoneNumber}
                                        text={this.getWhatsAppText()}
                                    >
                                        <Button
                                            color="primary"
                                            variant="contained"
                                            size="small"
                                        >
                                            <WhatsAppIcon />
                                        </Button>
                                    </WhatsAppLinkWrapper>
                                </Grid>
                                <Grid item wrap="nowrap">
                                    <Typography
                                        variant="subtitle1"
                                        color="default"
                                        style={{
                                            marginRight: 20,
                                            textAlign: 'left',
                                            wordWrap: 'break-word',
                                        }}
                                    >
                                        {
                                            strings.trackingLinkSendWhatsAppMessage
                                        }
                                    </Typography>
                                </Grid>
                            </Grid>
                        )}
                        {(!this.existsString(mobilePhoneNumber) ||
                            !this.existsString(mail)) &&
                        !canSendSms ? null : (
                            <Grid
                                container
                                item
                                wrap="nowrap"
                                justify="flex-start"
                                style={{
                                    marginLeft: 10,
                                    marginRight: 0,
                                    marginTop: 5,
                                    marginBottom: 5,
                                }}
                            >
                                <Grid item style={{ marginLeft: 0 }}>
                                    <Button
                                        color="primary"
                                        variant="contained"
                                        size="small"
                                        onClick={() => this.sendSms(orderId)}
                                    >
                                        <QrCodeIcon />
                                    </Button>
                                </Grid>
                                <Grid
                                    item
                                    zeroMinWidth
                                    style={{ marginLeft: 16 }}
                                >
                                    <Typography
                                        variant="subtitle1"
                                        color="default"
                                        style={{
                                            margin: 0,
                                            textAlign: 'left',
                                            wordWrap: 'break-word',
                                        }}
                                    >
                                        {strings.trackingSendCollectCode}
                                    </Typography>
                                </Grid>
                            </Grid>
                        )}

                        <Grid
                            container
                            item
                            wrap="nowrap"
                            justify="flex-start"
                            style={{
                                marginLeft: 10,
                                marginRight: 0,
                                marginTop: 5,
                                marginBottom: 5,
                            }}
                        >
                            <Grid item style={{ marginLeft: 0 }}>
                                <Copy
                                    color="inherit"
                                    text={url}
                                    onSuccess={() =>
                                        this.showNotification('Copiado')
                                    }
                                >
                                    <Button
                                        color="primary"
                                        variant="contained"
                                        size="small"
                                    >
                                        <CopyIcon
                                            color="inherit"
                                            style={{ width: 24, height: 24 }}
                                        />
                                    </Button>
                                </Copy>
                            </Grid>
                            <Grid item zeroMinWidth style={{ marginLeft: 16 }}>
                                <Typography
                                    variant="subtitle1"
                                    color="default"
                                    style={{ margin: 0, textAlign: 'left' }}
                                >
                                    {strings.trackingLinkShareLink}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Popover>
                <Typography
                    variant="subtitle1"
                    color="default"
                    style={{ margin: '0px 0px', textAlign: 'right' }}
                >
                    <strong>{strings.trackingLinkLabel}</strong>
                    <IconButton
                        onClick={(e) =>
                            this.setState({ anchorEl: e.currentTarget })
                        }
                    >
                        <ShareIcon fontSize="small" />
                    </IconButton>
                </Typography>
            </div>
        )
    }

    existsString = (string) => {
        if (string && string !== '') return true
        return false
    }

    getMailBody = () => {
        return strings.trackingMailBody + this.props.url
    }

    getWhatsAppText = () => {
        return strings.trackingWhatsAppBody + this.props.url
    }

    getMailSubject() {
        return strings.trackingMailSubjec
    }
}

export default TrackingShare
